import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './evalDirectMangerFromEmpPopup.scss'
 
export default function EvalDirectMangerFromEmpPopup({reason,firstWord}) {

    return (
        <div>
          
            <Popup trigger=
                {  <span className='text_inPopUp' dir='rtl'>{firstWord}</span>}
                position="bottom center"
                >
                <div className='EvalDirectMangerFromEmpPopup_div_container' dir='rtl'><p dir='rtl'>{reason}</p></div>
            </Popup>
        </div>
    )
};